import {LoaderActionType as ActionType} from "../action-types/loaderActionType";
import {LoaderAction as Action} from "../actions/loaderActions";

export enum LoadingStateFields {
    Loading = 'loading',
    Message = 'message'
}

export type LoadingState = {
    [LoadingStateFields.Loading]: boolean,
    [LoadingStateFields.Message]?: string
}

const initialLoading : LoadingState = {
    [LoadingStateFields.Loading]: false,
    [LoadingStateFields.Message]: undefined
}

export const loaderReducer = (state: LoadingState = initialLoading, action: Action): LoadingState => {
    switch (action.type) {
        case ActionType.SHOW_LOADER:
            return {
                ...state,
                [LoadingStateFields.Loading]: true,
                [LoadingStateFields.Message]: (action.payload as string) || undefined
            }
        case ActionType.HIDE_LOADER:
            return {
                ...state,
                [LoadingStateFields.Loading]: false,
                [LoadingStateFields.Message]: undefined
            }

        default:
            return { ...state }
    }
}